"use client";

import ArticleBody from "./ArticleBody";

interface Section {
  heading: string;
  body: string;
}

function splitByH2(content: string): { intro: string; sections: Section[] } {
  const lines = content.split("\n");
  let inCodeBlock = false;
  const intro: string[] = [];
  const sections: { heading: string; body: string[] }[] = [];
  let current: { heading: string; body: string[] } | null = null;

  for (const line of lines) {
    const trimmed = line.trimStart();
    if (trimmed.startsWith("```")) {
      inCodeBlock = !inCodeBlock;
    }

    if (!inCodeBlock && trimmed.startsWith("## ")) {
      if (current) {
        sections.push(current);
      }
      current = {
        heading: trimmed.replace("## ", "").trim(),
        body: [],
      };
    } else if (current) {
      current.body.push(line);
    } else {
      intro.push(line);
    }
  }

  if (current) {
    sections.push(current);
  }

  return {
    intro: intro.join("\n").trim(),
    sections: sections.map((s) => ({
      heading: s.heading,
      body: s.body.join("\n").trim(),
    })),
  };
}

interface SectionedArticleProps {
  content: string;
}

export default function SectionedArticle({ content }: SectionedArticleProps) {
  const { intro, sections } = splitByH2(content);

  return (
    <div className="flex flex-col col-12">
      {intro && (
        <div className="grid-container grid-padded mb-12">
          <div className="col-start-1 col-end-10">
            <ArticleBody content={intro} />
          </div>
        </div>
      )}

      {sections.map((section, i) => (
        <div
          key={i}
          className="article-grid grid-container grid-padded py-10 lg:py-16 border-t border-foreground/10"
        >
          <div className="col-3 mb-6 lg:mb-0">
            <h2 className="text-lg lg:text-lg font-black uppercase leading-tight tracking-tight lg:sticky lg:top-[120px]">
              {section.heading}
            </h2>
          </div>
          <div className="col-end-13 col-start-5">
            <ArticleBody content={section.body} />
          </div>
        </div>
      ))}
    </div>
  );
}
